'use client'

import { useGetQuestionsQuery } from '@/shared/api-rtk/index.js'
import { useEffect, useState } from 'react'
import QuestionItem from '@/entities/questions-page/QuestionItem/index.js'

export const Questions = () => {
    const { data, error } = useGetQuestionsQuery()
    const [questions, setQuestions] = useState([])
    const [initialCountQuestions, setInitialCountQuestions] = useState(5)

    const limitQuestions = initialCountQuestions > questions.length

    useEffect(() => {
        if (data?.result === 'success') {
            setQuestions(Object.values(data?.data).reverse());
        }
    }, [data])

    return (
        questions.length && 
        <div className={'Questions'}>
            <h2>Вопросы других пользователей</h2>
            <div className={'items'}>
                {questions
                    ?.slice(0, initialCountQuestions)
                    .map((question, index) => (
                        <QuestionItem key={index} {...question} />
                    ))}
            </div>
            {!limitQuestions && (
                <div className={'action'}>
                    <button
                        onClick={() =>
                            setInitialCountQuestions((state) => state + 5)
                        }
                    >
                        <img
                            src="/icons/showMore.svg"
                            alt="Иконка загрузки новых вопросов"
                        />
                        <span>Показать ещё</span>
                    </button>
                </div>
            )}
        </div>
    )
}
